import { Card, CardContent } from "@mui/material";
import React from "react";

export default function CompareInvoiceCard(props) {
  return (
    <Card
      style={{
        width: "100%",
        height: "calc(100vh - 64px - 16px)",
      }}
    >
      <CardContent style={{ height: "100%", backgroundColor: "transparent" }}>
        {props.children}
      </CardContent>
    </Card>
  );
}
